var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.351,
    height: 14.439,
    viewBox: "0 0 18.351 14.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3057",
    "data-name": "Group 3057",
    transform: "translate(-872 -7827.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_10",
    "data-name": "Line 10",
    d: "M11.914.611H-.119A.731.731,0,0,1-.85-.119.731.731,0,0,1-.119-.85H11.914a.731.731,0,0,1,.731.731A.731.731,0,0,1,11.914.611Z",
    transform: "translate(877.706 7840.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_8",
    "data-name": "Line 8",
    d: "M11.914.611H-.119A.731.731,0,0,1-.85-.119.731.731,0,0,1-.119-.85H11.914a.731.731,0,0,1,.731.731A.731.731,0,0,1,11.914.611Z",
    transform: "translate(877.706 7828.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_9",
    "data-name": "Line 9",
    d: "M11.914.611H-.119A.731.731,0,0,1-.85-.119.731.731,0,0,1-.119-.85H11.914a.731.731,0,0,1,.731.731A.731.731,0,0,1,11.914.611Z",
    transform: "translate(877.706 7834.493)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 1.203,
    cy: 1.203,
    r: 1.203,
    transform: "translate(872 7827.068)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 1.203,
    cy: 1.203,
    r: 1.203,
    transform: "translate(872 7833.085)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 1.203,
    cy: 1.203,
    r: 1.203,
    transform: "translate(872 7839.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_10-2",
    "data-name": "Line 10",
    d: "M11.914.611H-.119A.731.731,0,0,1-.85-.119.731.731,0,0,1-.119-.85H11.914a.731.731,0,0,1,.731.731A.731.731,0,0,1,11.914.611Z",
    transform: "translate(877.706 7840.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_8-2",
    "data-name": "Line 8",
    d: "M11.914.611H-.119A.731.731,0,0,1-.85-.119.731.731,0,0,1-.119-.85H11.914a.731.731,0,0,1,.731.731A.731.731,0,0,1,11.914.611Z",
    transform: "translate(877.706 7828.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_9-2",
    "data-name": "Line 9",
    d: "M11.914.611H-.119A.731.731,0,0,1-.85-.119.731.731,0,0,1-.119-.85H11.914a.731.731,0,0,1,.731.731A.731.731,0,0,1,11.914.611Z",
    transform: "translate(877.706 7834.493)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11-2",
    "data-name": "Ellipse 11",
    cx: 1.203,
    cy: 1.203,
    r: 1.203,
    transform: "translate(872 7827.068)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12-2",
    "data-name": "Ellipse 12",
    cx: 1.203,
    cy: 1.203,
    r: 1.203,
    transform: "translate(872 7833.085)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13-2",
    "data-name": "Ellipse 13",
    cx: 1.203,
    cy: 1.203,
    r: 1.203,
    transform: "translate(872 7839.101)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavContacts);
export default __webpack_public_path__ + "static/media/Nav-Contacts.3d4b7ab07a3f47dac72703fb7240a362.svg";
export { ForwardRef as ReactComponent };